import ReactQuill from "react-quill";
import { callAxios, convertFileToBase64, customToast, dev_console, getFileHash, printStateMsg } from "../../../../Common/ts/commonTools";

const setImgTag = (
    {
        quillRef,
        url,
        width,
        file_hash,
        upload_file_detail_pk,
        cursorPositionRef,
    }:{
        quillRef:React.MutableRefObject<ReactQuill | undefined>;
        url: string;
        width: string;
        file_hash: string;
        upload_file_detail_pk: number;
        cursorPositionRef: React.MutableRefObject<number | null>;
    }
) => {
    // 커서의 위치를 알고 해당 위치에 이미지 태그를 넣어주는 코드
    // 해당 DOM의 데이터가 필요하기에 useRef를 사용한다.
    // 커서 위치 가져오기
    // let range = cursorPosition || quillRef.current?.getEditor().getSelection()?.index;

    let range: number | null |undefined = null;

    RangeSetting:{
        if(typeof cursorPositionRef.current === "number"){
            range = cursorPositionRef.current;
            break RangeSetting;
        }

        if(cursorPositionRef.current === null){
            range = quillRef.current?.getEditor().getSelection()?.index;
        }

    }

    // 커서 위치가 없으면 마지막 위치로 설정
    if (typeof range !== "number") {
        range = quillRef.current?.getEditor().getLength();
    }

    if (typeof range === "number" && quillRef.current) {

        let quill = quillRef.current.getEditor();

        quill.setSelection(range, 1);

        quill.clipboard.dangerouslyPasteHTML(
            range,
            `<img src="${url}" width="${width}" data-file-hash="${file_hash}" data-upload-file-detail-pk="${upload_file_detail_pk}" />`
        );

        // // 커서를 이미지 뒤로 이동시키고, 선택을 제거함
        // quill.setSelection(range + 1, 0);

        // // 이미지 뒤에 줄바꿈 추가 (필요시)
        // quill.insertText(range + 1, '\n');

        cursorPositionRef.current = range + 1;
    }
}

export const textEditerHandleImageUpload = async (
    {
        formData,
        quillRef,
        width,
        cursorPositionRef
    }:{
        formData: FormData;
        quillRef:React.MutableRefObject<ReactQuill | undefined>;
        width: string;
        cursorPositionRef: React.MutableRefObject<number | null>;
    }
) => {

    // formData 구성
    // office_id: 지점 id
    // thema_id: 테마 id -> 테마북 외의 공간에서 사용할때는 0으로 처리
    // type: 테마북의 detail list에서 보여주는 type -> 테마북 외의 공간에서 사용할때는 0으로 처리
    // file_field: 이미지파일

    // const manager_image_url = 'api/v3/customers/thema-book-content-img-upload';
    // const result = await callAxios.api({
    //     url: manager_image_url,
    //     method: 'post',
    //     data: formData
    // })
    // if(result){
    //     dev_console.log(manager_image_url);
    //     dev_console.log(result);

    //     if(result.status === 200 && result.data.status === "OK"){

    //         const url = result.data.img_url;

    //         setImgTag({
    //             quillRef,
    //             url,
    //             width,
    //             cursorPositionRef,
    //         })
    //     }else{
    //         printStateMsg(result);
    //         customToast.error({msg: "사진 추가에 실패했습니다."});
    //     }
    // }else{
    //     printStateMsg(result);
    //     customToast.error({msg: "사진 추가에 실패했습니다."});
    // }

    const files = formData.get("file_field");
    if(!files){
        return;
    }
    const file_hash = await getFileHash(files as File);

    const upload_file_detail_pk = 0;

    const base64 = await convertFileToBase64(files as File);

    setImgTag({
        quillRef,
        url: base64 as string,
        width,
        file_hash,
        upload_file_detail_pk,
        cursorPositionRef,
    })
}